// src/navigation/setting/types.ts
var NavigationSettingAriResourceOwner = "navigation", NavigationSettingAriResourceType = "setting";

export {
  NavigationSettingAriResourceOwner,
  NavigationSettingAriResourceType
};
